import React from "react";
import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import SectionHeading from "@/components/site/SectionHeading";
import QuoteForm from "@/components/site/QuoteForm";
import { BRAND, WHATSAPP_URL } from "@/lib/site";

export default function Contato() {
  return (
    <>
      <section className="bg-white border-b border-surface-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-24">
          <div className="text-xs font-bold uppercase tracking-[0.22em] text-bronze">
            Contato
          </div>
          <h1 className="mt-4 font-display font-black text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight max-w-4xl">
            <span className="text-brand">Fale com a Wellpec.</span> Resposta
            rápida e objetiva.
          </h1>
          <p className="mt-6 text-lg text-ink-muted leading-relaxed max-w-2xl">
            Atendimento comercial e técnico para cotações, contratos de
            fornecimento e suporte em operações industriais.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-24 bg-surface-alt border-b border-surface-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-10">
          <aside className="lg:col-span-4">
            <SectionHeading
              eyebrow="Canais diretos"
              title="Como falar com a gente."
            />
            <div className="mt-8 space-y-5">
              <a
                href={`mailto:${BRAND.email}`}
                data-testid="contato-email"
                className="flex items-start gap-4 p-5 bg-white border border-surface-line rounded-sm hover:border-bronze/40 transition-colors"
              >
                <span className="h-11 w-11 rounded-sm bg-brand text-white flex items-center justify-center">
                  <Mail className="h-5 w-5" />
                </span>
                <span>
                  <div className="text-xs font-bold uppercase tracking-wider text-ink-muted">
                    E-mail comercial
                  </div>
                  <div className="mt-1 font-semibold text-ink break-all">
                    {BRAND.email}
                  </div>
                </span>
              </a>
              <a
                href={WHATSAPP_URL()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="contato-whatsapp"
                className="flex items-start gap-4 p-5 bg-white border border-surface-line rounded-sm hover:border-bronze/40 transition-colors"
              >
                <span className="h-11 w-11 rounded-sm bg-[#25D366] text-white flex items-center justify-center">
                  <MessageCircle className="h-5 w-5" />
                </span>
                <span>
                  <div className="text-xs font-bold uppercase tracking-wider text-ink-muted">
                    WhatsApp
                  </div>
                  <div className="mt-1 font-semibold text-ink">
                    {BRAND.whatsappDisplay}
                  </div>
                </span>
              </a>
              <div
                data-testid="contato-phone"
                className="flex items-start gap-4 p-5 bg-white border border-surface-line rounded-sm"
              >
                <span className="h-11 w-11 rounded-sm bg-brand text-white flex items-center justify-center">
                  <Phone className="h-5 w-5" />
                </span>
                <span>
                  <div className="text-xs font-bold uppercase tracking-wider text-ink-muted">
                    Telefone
                  </div>
                  <div className="mt-1 font-semibold text-ink">
                    {BRAND.phone}
                  </div>
                </span>
              </div>
              <div
                data-testid="contato-address"
                className="flex items-start gap-4 p-5 bg-white border border-surface-line rounded-sm"
              >
                <span className="h-11 w-11 rounded-sm bg-brand text-white flex items-center justify-center">
                  <MapPin className="h-5 w-5" />
                </span>
                <span>
                  <div className="text-xs font-bold uppercase tracking-wider text-ink-muted">
                    Endereço
                  </div>
                  <div className="mt-1 font-semibold text-ink">
                    {BRAND.address}
                  </div>
                </span>
              </div>
            </div>
          </aside>
          <div className="lg:col-span-8">
            <QuoteForm source="contato" />
          </div>
        </div>
      </section>
    </>
  );
}
